import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/banner_30min.jpg'
import _imports_1 from '@/assets/banner_2hr_visit.jpg'
import _imports_2 from '@/assets/banner_nomination.jpg'


const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 2,
  class: "achieve-jupas-wrapper"
}
const _hoisted_7 = { key: 3 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "ion-text-center" }
const _hoisted_10 = { class: "ion-text-center" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "ion-text-center" }
const _hoisted_13 = { key: 4 }
const _hoisted_14 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_TeacherItemQRCodeSharing = _resolveComponent("TeacherItemQRCodeSharing")!
  const _component_TeacherItemSchoolReadiness = _resolveComponent("TeacherItemSchoolReadiness")!
  const _component_TeacherAchieveJUPASModal = _resolveComponent("TeacherAchieveJUPASModal")!
  const _component_service_item = _resolveComponent("service-item")!
  const _component_action_accordion_group = _resolveComponent("action-accordion-group")!
  const _component_home_action_item = _resolveComponent("home-action-item")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_badge = _resolveComponent("ion-badge")!

  return ($setup.loadingData)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_ion_spinner)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(_component_ion_toolbar, { class: "sticky-toolbar" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_segment, {
              class: "view-type-segment",
              mode: "ios",
              modelValue: $setup.selectedViews.type,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedViews.type) = $event)),
              scrollable: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_segment_button, {
                  value: "Sharing",
                  class: "short-segment-btn"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      size: "small",
                      icon: $setup.qrCodeOutline
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_segment_button, { value: "Checklist" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => _cache[9] || (_cache[9] = [
                        _createElementVNode("b", null, "Checklist", -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_segment_button, { value: "AchieveJUPAS" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, {
                      style: {"line-height":"1.5"},
                      class: "no-text-transform"
                    }, {
                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                        _createElementVNode("b", null, "AchieveJUPAS", -1),
                        _createElementVNode("br", null, null, -1),
                        _createTextVNode("2.0 (beta)")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_segment_button, { value: "AchieveSLP" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, {
                      style: {"line-height":"1.5"},
                      class: "no-text-transform"
                    }, {
                      default: _withCtx(() => _cache[11] || (_cache[11] = [
                        _createElementVNode("b", null, "AchieveSLP", -1),
                        _createElementVNode("br", null, null, -1),
                        _createTextVNode("events")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_segment_button, { value: "school-funded" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, {
                      style: {"line-height":"1.5"},
                      class: "no-text-transform"
                    }, {
                      default: _withCtx(() => _cache[12] || (_cache[12] = [
                        _createTextVNode("School-funded")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            ($setup.selectedViews.type == 'AchieveSLP')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_ion_segment, {
                    mode: "ios",
                    modelValue: $setup.selectedViews.subType,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.selectedViews.subType) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_segment_button, { value: "resources" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => _cache[13] || (_cache[13] = [
                              _createTextVNode("School-based")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_segment_button, { value: "nomination" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => _cache[14] || (_cache[14] = [
                              _createTextVNode("Joint-school")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_ion_toolbar, { style: {"--min-height":"27px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, {
                        lines: "full",
                        button: "",
                        detail: "",
                        color: "fdmtred",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.openSLPModal(true)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { class: "ion-text-wrap ion-text-center" }, {
                            default: _withCtx(() => _cache[15] || (_cache[15] = [
                              _createElementVNode("p", { style: {"margin":"0","color":"#fff"} }, "AchieveSLP preview", -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        ($setup.selectedViews.type == 'Sharing')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_TeacherItemQRCodeSharing)
            ]))
          : _createCommentVNode("", true),
        ($setup.selectedViews.type == 'Checklist')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_TeacherItemSchoolReadiness)
            ]))
          : _createCommentVNode("", true),
        ($setup.selectedViews.type == 'AchieveJUPAS')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_TeacherAchieveJUPASModal, { isDemo: true })
            ]))
          : _createCommentVNode("", true),
        ($setup.selectedViews.type === 'AchieveSLP')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              ($setup.selectedViews.subType === 'resources')
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _cache[16] || (_cache[16] = _createElementVNode("img", {
                      src: _imports_0,
                      style: {"width":"100%","margin-bottom":"-3px"}
                    }, null, -1)),
                    _createVNode(_component_action_accordion_group, {
                      "no-accordion": true,
                      "no-header": true
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getServicesByNature('Talk at your school'), (service) => {
                            return (_openBlock(), _createBlock(_component_service_item, {
                              key: service.id,
                              service: service
                            }, null, 8, ["service"]))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    }),
                    _cache[17] || (_cache[17] = _createElementVNode("img", {
                      src: _imports_1,
                      style: {"width":"100%","margin-bottom":"-3px"}
                    }, null, -1)),
                    _createVNode(_component_action_accordion_group, {
                      "no-accordion": true,
                      "no-header": true
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_10, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getServicesByNature('Visit'), (service) => {
                            return (_openBlock(), _createBlock(_component_service_item, {
                              key: service.id,
                              service: service
                            }, null, 8, ["service"]))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    })
                  ]))
                : ($setup.selectedViews.subType === 'nomination')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _cache[18] || (_cache[18] = _createElementVNode("img", {
                        src: _imports_2,
                        style: {"width":"100%","margin-bottom":"-3px"}
                      }, null, -1)),
                      _createVNode(_component_action_accordion_group, {
                        "no-accordion": true,
                        "no-header": true
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_12, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getServicesByNature('Workshop'), (service) => {
                              return (_openBlock(), _createBlock(_component_service_item, {
                                key: service.id,
                                service: service
                              }, null, 8, ["service"]))
                            }), 128))
                          ])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        ($setup.selectedViews.type == 'school-funded')
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (!$setup.isAB4User)
                ? (_openBlock(), _createBlock(_component_ion_item, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, {
                        class: "ion-text-wrap",
                        style: {"line-height":"1"}
                      }, {
                        default: _withCtx(() => _cache[19] || (_cache[19] = [
                          _createElementVNode("i", null, "School-funded services for F4 & F3 only available upon school request after 3+ years of university-funded service", -1)
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_action_accordion_group, { "no-accordion": true }, {
                header: _withCtx(() => _cache[20] || (_cache[20] = [
                  _createElementVNode("span", null, [
                    _createElementVNode("b", null, "Bluebird Seed")
                  ], -1)
                ])),
                default: _withCtx(() => [
                  ($setup.user.schoolId == 'htc')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createVNode(_component_home_action_item, {
                          isLesson: true,
                          title: "Videos and regulations",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.openServiceModal('bluebird-seed', null, { hideApplyBtn: true })))
                        }),
                        _createVNode(_component_action_accordion_group, {
                          "no-accordion": false,
                          "header-color": 'none',
                          "no-padding": true
                        }, {
                          header: _withCtx(() => [
                            _createVNode(_component_ion_item, { lines: "full" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => _cache[21] || (_cache[21] = [
                                    _createElementVNode("b", null, "5D22 Ng Wing Sum Chloe", -1)
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_ion_buttons, { slot: "end" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_button, {
                                      class: "no-text-transform",
                                      size: "small",
                                      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => ($setup.openUserDetails()), ["stop"]))
                                    }, {
                                      default: _withCtx(() => _cache[22] || (_cache[22] = [
                                        _createTextVNode("Profile")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_ion_item, {
                              lines: "full",
                              style: {"padding-left":"32px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  slot: "start",
                                  icon: $setup.checkmarkCircle,
                                  color: "success"
                                }, null, 8, ["icon"]),
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => _cache[23] || (_cache[23] = [
                                    _createElementVNode("b", null, "Nominator: Ms. Lillian Ho", -1)
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, {
                              lines: "full",
                              style: {"padding-left":"32px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => _cache[24] || (_cache[24] = [
                                    _createElementVNode("b", null, "Co-supervisors: Ms. Lilian Ho (HTC), Brandon Chan (FDMT)", -1)
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_action_accordion_group, {
                              style: {"padding-left":"20px"},
                              "no-accordion": false,
                              "header-color": 'none',
                              "no-padding": true
                            }, {
                              header: _withCtx(() => [
                                _createVNode(_component_ion_item, { lines: "full" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, null, {
                                      default: _withCtx(() => _cache[25] || (_cache[25] = [
                                        _createElementVNode("b", null, "Project logs", -1)
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_ion_item, {
                                  button: "",
                                  lines: "full",
                                  style: {"padding-left":"32px"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                      default: _withCtx(() => _cache[26] || (_cache[26] = [
                                        _createElementVNode("b", null, "AchieveJUPAS UI Updates", -1),
                                        _createElementVNode("p", null, "Show version history of program choices", -1),
                                        _createElementVNode("p", null, "Expected completion: 2025-04-30", -1)
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_badge, {
                                      color: "medium",
                                      slot: "end"
                                    }, {
                                      default: _withCtx(() => _cache[27] || (_cache[27] = [
                                        _createTextVNode("Planned")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_action_accordion_group, { "no-accordion": true }, {
                header: _withCtx(() => _cache[28] || (_cache[28] = [
                  _createElementVNode("span", null, [
                    _createElementVNode("b", null, "Form 4")
                  ], -1)
                ])),
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, {
                    lines: "full",
                    button: "",
                    detail: "",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.openAB4CustomizeContentModal())),
                    disabled: !$setup.user.isAdmin && !$setup.isAB4User
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                        default: _withCtx(() => _cache[29] || (_cache[29] = [
                          _createElementVNode("p", null, "Pre-session customization for your school", -1)
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_ion_item, {
                    lines: "full",
                    button: "",
                    detail: "",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.openABEventsModal('abs-session1'))),
                    disabled: !$setup.isAB4User
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                        default: _withCtx(() => _cache[30] || (_cache[30] = [
                          _createElementVNode("p", null, "[80+ min] Lesson 1", -1)
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_ion_item, {
                    lines: "full",
                    button: "",
                    detail: "",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.openABEventsModal('abs-session2'))),
                    disabled: !$setup.isAB4User
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                        default: _withCtx(() => _cache[31] || (_cache[31] = [
                          _createElementVNode("p", null, "[40+ min] Lesson 2", -1)
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_ion_item, {
                    lines: "full",
                    button: "",
                    detail: "",
                    disabled: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        size: "small",
                        color: "danger",
                        icon: $setup.alertCircle
                      }, null, 8, ["icon"]),
                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                        default: _withCtx(() => _cache[32] || (_cache[32] = [
                          _createTextVNode("Manage student worries")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_action_accordion_group, { "no-accordion": true }, {
                header: _withCtx(() => _cache[33] || (_cache[33] = [
                  _createElementVNode("span", null, [
                    _createElementVNode("b", null, "AchieveElective")
                  ], -1)
                ])),
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, {
                    lines: "full",
                    button: "",
                    detail: "",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.openABEventsModal('ab3-session1'))),
                    disabled: !$setup.isAB4User
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                        default: _withCtx(() => _cache[34] || (_cache[34] = [
                          _createElementVNode("p", null, "[45+ min] Lesson 1", -1)
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]))
}